import {
  actions,
  getSuggestContentDataTableAsync,
  createSuggestContentAsync,
} from './slices';

export const SuggestContentActions = {
  ...actions,
  getSuggestContentDataTableAsync,
  createSuggestContentAsync,
};
